import React from "react"

import globalStyles from "../../../../App.module.scss";

export default function ProcessManagement() {
    return (
        <div className={globalStyles.article}>
            <h1>Process management</h1>

            <h3>Listing processes</h3>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> ps aux <i># every process, BSD style</i><br/>
    <b>user@host:~$</b> ps -ef <i># every process, UNIX style, shows PPID</i><br/>
    <b>user@host:~$</b> pgrep -fl node <i># find processes by name</i><br/>
    <b>user@host:~$</b> top <i># live view, sorted by CPU</i><br/>
    <b>user@host:~$</b> htop <i># nicer live view (needs installing)</i><br/>
            </pre>

            <h3>Killing processes</h3>
            <p><code>kill</code> sends a signal to a process, it doesn't necessarily terminate it — that depends on
                which signal, and whether the process handles it.</p>

            <div className={globalStyles.styledTable}>
                <table style={{minWidth: '330px'}}>
                    <thead>
                    <tr>
                        <th colSpan="3">Common signals</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td><b>1</b></td>
                        <td>SIGHUP</td>
                        <td>Reload config (convention for daemons) or hang-up</td>
                    </tr>
                    <tr>
                        <td><b>2</b></td>
                        <td>SIGINT</td>
                        <td>Interrupt, same as Ctrl+C</td>
                    </tr>
                    <tr>
                        <td><b>9</b></td>
                        <td>SIGKILL</td>
                        <td>Force kill immediately, can't be caught or ignored — last resort</td>
                    </tr>
                    <tr>
                        <td><b>15</b></td>
                        <td>SIGTERM</td>
                        <td>Ask nicely to terminate (the default signal for <code>kill</code>)</td>
                    </tr>
                    <tr>
                        <td><b>18</b></td>
                        <td>SIGCONT</td>
                        <td>Resume a stopped process</td>
                    </tr>
                    <tr>
                        <td><b>19</b></td>
                        <td>SIGSTOP</td>
                        <td>Pause a process, can't be caught or ignored</td>
                    </tr>
                    </tbody>
                </table>
            </div>

            <pre className={globalStyles.code}>
    <b>user@host:~$</b> kill 1234 <i># sends SIGTERM to PID 1234</i><br/>
    <b>user@host:~$</b> kill -9 1234 <i># SIGKILL, use only if SIGTERM was ignored</i><br/>
    <b>user@host:~$</b> pkill -f "node server.js" <i># kill by matching command line</i><br/>
    <b>user@host:~$</b> killall nginx <i># kill every process with this name</i><br/>
            </pre>

            <p>Always try <b>SIGTERM</b> before <b>SIGKILL</b> — it gives the process a chance to close files,
                flush buffers and shut down cleanly. SIGKILL just yanks it out, which can leave temp files,
                locks or corrupted state behind.</p>

            <h3>Priority: nice &amp; renice</h3>
            <p>Niceness ranges from <b>-20</b> (highest priority) to <b>19</b> (lowest). Only root can set a
                negative value.</p>
            <pre className={globalStyles.code}>
    <b>user@host:~$</b> nice -n 10 ./long-batch-job.sh <i># start with lower priority</i><br/>
    <b>root@host:~#</b> renice -n -5 -p 1234 <i># raise priority of a running process</i><br/>
            </pre>
        </div>
    )
}
